<template>
  <base-section
  id="committees"
  >
    <v-container>
    <base-section-heading
    title="Organizing Committee"
    color="red"
    align="left"
    :toColor="true"
    >
    <br>
    <organizing-committee />
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  import OrganizingCommittee from './OrganizingCommittee.vue'
  export default {
    name: 'Committees',
    components: { OrganizingCommittee },

    data: () => ({

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
